import { render, staticRenderFns } from "./newadd.vue?vue&type=template&id=255a628e&scoped=true&"
import script from "./newadd.vue?vue&type=script&lang=js&"
export * from "./newadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a628e",
  null
  
)

export default component.exports